export let laravelProjects = [
    {
        title: "Laravel Bugtracker",
        link: "https://github.com/VocalNight/Laravel_Bugtracker",
        description: "A bugtracker made in laravel for personal use and to learn PHP."
    }
]
